<template>
  <BaseFetchData :action="fetchData">
    <!-- props
      fetchData, status.loading, status.resolved, status.rejected, rejectReason
    -->
    <template #default="fetchDataProps">
      <ul v-if="fetchDataProps.status.resolved" role="list" class="divide-y divide-gray-200">
        <SmsMessageListItem
          v-for="smsMessage in smsMessages"
          :key="smsMessage.id"
          :focused="currentSmsMessage && smsMessage.id === currentSmsMessage.id"
          :sms-message="smsMessage"
          @sms-message:focus="handleSmsMessageFocus"
          @sms-message:edit="handleSmsMessageEdit"
          @sms-message:delete="handleSmsMessageDelete"
        />
      </ul>
    </template>
  </BaseFetchData>
</template>

<script>
import { pipelineStageSmsMessagesClient } from '@/api/clients';
import SmsMessageListItem from './SmsMessageListItem.vue';

export default {
  components: {
    SmsMessageListItem,
  },
  props: {
    currentSmsMessage: {
      type: Object,
      default: () => null,
    },
    pipelineStageId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      smsMessages: [],
    };
  },
  methods: {
    handleSmsMessageFocus(smsMessage) {
      this.$emit('sms-message:focus', smsMessage);
    },
    handleSmsMessageEdit(smsMessage) {
      this.$emit('sms-message:edit', smsMessage);
    },
    handleSmsMessageDelete(smsMessage) {
      this.$emit('sms-message:delete', smsMessage);
    },
    fetchData() {
      return pipelineStageSmsMessagesClient
        .list(this.pipelineStageId, {
          include: 'user,tracking_logs_count',
          sort: '-created_at',
        })
        .then((response) => {
          this.smsMessages = response.data;

          return Promise.resolve(response);
        })
        .finally(() => {
          this.handleSmsMessageFocus(this.smsMessages?.[0] || null);
        });
    },
  },
};
</script>
